// context/TaggedMessagesContext.js
// Shared store so MessageInputBox can push tagged messages
// and RightRail can display them — no prop drilling needed.
import { createContext, useContext, useState, useCallback } from "react";

const TaggedMessagesContext = createContext(null);

export function TaggedMessagesProvider({ children }) {
  const [tagged, setTagged] = useState([]);

  const addTaggedMessage = useCallback((msg) => {
    // msg: { id, text, tag, senderName, ts, chatWith }
    setTagged(prev => {
      // deduplicate by id
      if (prev.find(m => m.id === msg.id)) return prev;
      return [msg, ...prev].slice(0, 50); // keep latest 50
    });
  }, []);

  const dismissTaggedMessage = useCallback((id) => {
    setTagged(prev => prev.filter(m => m.id !== id));
  }, []);

  return (
    <TaggedMessagesContext.Provider value={{ tagged, addTaggedMessage, dismissTaggedMessage }}>
      {children}
    </TaggedMessagesContext.Provider>
  );
}

export function useTaggedMessages() {
  const ctx = useContext(TaggedMessagesContext);
  if (!ctx) throw new Error("useTaggedMessages must be inside TaggedMessagesProvider");
  return ctx;
}
